module.exports = __webpack_public_path__ + "static/media/status-error.6ce917ec.svg";